import { IJournalHighlightsItem } from '../../types/journal';

export function journalHighlightsReducer(
  state: IJournalHighlightsItem[] | null = null,
): IJournalHighlightsItem[] | null {
  return state;
}
